/**
 * Answer Campaign（回答実施）API client
 * 会社ごとの GB人財 回答実施（回答開始日）の CRUD。ADMIN 専用。
 * 設計: docs/回答実施_設計_2026-07-29.md
 */
import { createAuthenticatedClient } from '../../../shared/api/axiosClient';

const API_BASE_URL = import.meta.env.VITE_API_URL || '';

let apiClient: ReturnType<typeof createAuthenticatedClient> | null = null;

const getApiClient = () => {
  if (!apiClient) {
    apiClient = createAuthenticatedClient(API_BASE_URL, () => {
      window.location.href = '/login';
    });
  }
  return apiClient;
};

export interface AnswerCampaign {
  id: string;
  companyId: string | null;
  startDate: string; // YYYY-MM-DD
  questionSetId: string | null;
  questionSetTitle: string | null;
  label: string | null;
  createdAt: string | null;
}

export interface CreateAnswerCampaignDTO {
  companyId: string;
  startDate: string;
  questionSetId?: string | null;
  label?: string | null;
}

export interface UpdateAnswerCampaignDTO {
  startDate?: string;
  questionSetId?: string | null;
  label?: string | null;
}

export const answerCampaignApi = {
  async list(companyId: string): Promise<AnswerCampaign[]> {
    const client = getApiClient();
    const response = await client.get<{ campaigns: AnswerCampaign[] }>('/admin/answer-campaigns', {
      params: { companyId },
    });
    return response.data.campaigns;
  },

  async create(data: CreateAnswerCampaignDTO): Promise<AnswerCampaign> {
    const client = getApiClient();
    const response = await client.post<{ campaign: AnswerCampaign }>('/admin/answer-campaigns', data);
    return response.data.campaign;
  },

  async update(id: string, data: UpdateAnswerCampaignDTO): Promise<AnswerCampaign> {
    const client = getApiClient();
    const response = await client.put<{ campaign: AnswerCampaign }>(`/admin/answer-campaigns/${id}`, data);
    return response.data.campaign;
  },

  async remove(id: string): Promise<void> {
    const client = getApiClient();
    await client.delete(`/admin/answer-campaigns/${id}`);
  },
};
